import { Component, OnInit, ViewEncapsulation, Inject } from "@angular/core";
import { FormControl, FormGroup, FormBuilder, Validators, FormArray, ValidatorFn, AbstractControl } from "@angular/forms";
import { CommonService } from "../../shared/services/common/common.service";
import { UserService } from "../../shared/services/user/user.service";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { CustomerService } from "../../shared/services/customer/customer.service";

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {
  startOfW = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  settingForm: FormGroup;
  userSettings: any = {};
  isSubmitted: number = 0;
  constructor(public dialog: MatDialog, private fb: FormBuilder, private commonService: CommonService, private userService: UserService, private customerService: CustomerService) {
  }

  ngOnInit() {
    this.getUserData();
  }

  getUserData() {
    let userDetails = this.userService.getLoggedInUser();
    this.userSettings.localTimeZ = userDetails.settings.localOffSet ? userDetails.settings.localOffSet : "+00:00" || "+00:00";
    this.userSettings.dateTimeFormat = userDetails.settings.dateTimeFormat ? userDetails.settings.dateTimeFormat : "" || "YYYY-MM-DDTHH:mm:ss";
    this.userSettings.startOfWeek = userDetails.settings.startOfWeek ? userDetails.settings.startOfWeek : "1" || "1";
    this.userSettings.thousandSymbol = userDetails.settings.thousandSymbol ? userDetails.settings.thousandSymbol : ',';
    this.userSettings.decimalSymbol = userDetails.settings.decimalSymbol ? userDetails.settings.decimalSymbol : ".";
    this.createForm(this.userSettings);
  }

  openEditSettingDialog() {
    this.dialog.open(EditSettingDialog, {
      height: "auto",
      width: "400px",
      panelClass: "full-modal",
      data: this.userSettings
    });

    return false;
  }

  createForm(data) {
    this.settingForm = this.fb.group({
      thousandSymbol: [(data && data.thousandSymbol ? data.thousandSymbol : ','), Validators.compose([Validators.required, Validators.pattern('[^A-Za-z 0-9]')])],
      decimalSymbol: [(data && data.decimalSymbol ? data.decimalSymbol : '.'), Validators.compose([Validators.required, Validators.pattern('[^A-Za-z 0-9]')])],
    });
  }

  onSubmit(form: any) {
    if (!this.settingForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    this.userService.updateSymbol(form).subscribe(r => {
      this.isSubmitted = 0;
      this.userService.setSymbolSetting(form);
    }, error => {
      this.isSubmitted = 0;
    });
  }
}

@Component({
  selector: "edit-setting-dialog",
  templateUrl: "setting.dialog.html"
})
export class EditSettingDialog {
  settingForm: FormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private customerService: CustomerService,
    private userService: UserService,
    public dialogRef: MatDialogRef<EditSettingDialog>
  ) {
    this.createForm(data);
  }

  createForm(data) {
    this.settingForm = this.fb.group({
      localTimeZone: [data.localTimeZ, [Validators.required, Validators.pattern('^(?:|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])$')]],
      preferedDateFormt: [data.dateTimeFormat, [Validators.required]]
    });
  }
  // onSubmit(form: any) {
  //   if (!this.personalForm.valid) {
  //     return false;
  //   }
  //   this.isSubmitted = 1;
  //   form.customerId = this.data._id;

  //   this.customerService.update(form).subscribe(r => {
  //     this.userService.savePersonalDetailsToToken(form);
  //     this.dialogRef.close();
  //     this.isSubmitted = 0;
  //   }, err => {
  //     this.isSubmitted = 0;
  //   });
  // }
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/setting/setting.component.ts